module.exports = __webpack_public_path__ + "static/img/PN_H5.518159f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/PN_H5.png
// module id = 7ma7
// module chunks = 34